import { takeEvery } from 'redux-saga/effects';

import { resourceSagaUtils, resourceStoreTypes } from '../core';
import type { ResourceActionCreator, ResourceFailureActionCreator } from '../core/resourceStoreTypes';
import * as actions from './projectsActions';
import { getLastSyncDate } from './projectsSelectors';
import { transformProjectsToRequestData, transformResponseToProjects } from './projectsTransformers';
import type { ProjectProps } from './projectsTypes';

const mkQcsSyncProjectsConfig = resourceStoreTypes.createTypedQcsSyncResourcesConfigFactory<ProjectProps>();

const mkResourceConfig = (
  successAction: ResourceActionCreator<ProjectProps>,
  failureAction: ResourceFailureActionCreator,
) =>
  mkQcsSyncProjectsConfig({
    resourceName: 'projects',
    resourceBaseUrl: '/businesses/projects',
    getLastSyncDate,

    transformResponseToResources: transformResponseToProjects,
    transformResourceToRequestData: transformProjectsToRequestData,
    applyResourceFromCRUDResponse: true,

    successAction,
    failureAction,
  });

export function* getProjectsActionWatcher() {
  const resourceConfig = mkResourceConfig(actions.getProjectSuccess, actions.getProjectFailure);
  yield resourceSagaUtils.takeAndDebounce(
    actions.getProject,
    resourceSagaUtils.qcsSyncGetResources<ProjectProps>,
    resourceConfig,
  );
}

export function* createProjectsActionWatcher() {
  const resourceConfig = mkResourceConfig(actions.createProjectSuccess, actions.createProjectFailure);
  yield takeEvery(actions.createProject.type, resourceSagaUtils.qcsSyncCreateResource<ProjectProps>, resourceConfig);
}

export function* updateProjectsActionWatcher() {
  const resourceConfig = mkResourceConfig(actions.updateProjectSuccess, actions.updateProjectFailure);
  yield takeEvery(actions.updateProject.type, resourceSagaUtils.qcsSyncUpdateResource<ProjectProps>, resourceConfig);
}

export function* deleteProjectsActionWatcher() {
  const resourceConfig = mkResourceConfig(actions.deleteProjectSuccess, actions.deleteProjectFailure);
  yield takeEvery(actions.deleteProject.type, resourceSagaUtils.qcsSyncDeleteResource<ProjectProps>, resourceConfig);
}

export default [
  getProjectsActionWatcher,
  createProjectsActionWatcher,
  updateProjectsActionWatcher,
  deleteProjectsActionWatcher,
];
